import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../../firebase/config';
import { signOut } from './authService';

const getRegionalFunctions = () => getFunctions(app, 'europe-west10');

/**
 * GDPR right-to-erasure: permanently deletes the signed-in user's account —
 * uploaded videos, library/playlist data, shares they own, and the Firebase
 * Auth account itself — then signs out locally. Cannot be undone.
 */
export const deleteMyAccount = async (): Promise<void> => {
  const fn = httpsCallable(getRegionalFunctions(), 'deleteMyAccount');
  await fn();
  await signOut();
};
